

































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ShippingCompany from '@/api/shipping/index'
import PicModal from '@/components/upload/picModal.vue'

@Component({
  components: {
    PicModal,
  },
})
export default class EditCompany extends AbpBase {
  form = {
    expressCompanyName: null,
    code: null,
    phone: null,
    logo: null,
    displayOrder: 0,
    published: false,
    isDefault: false,
  }

  ruleForm = {
    logo: [{ required: true, message: '请选择logo', trigger: 'blur' }],
    expressCompanyName: [{ required: true, message: '请输入物流公司', trigger: 'blur' }],
    code: [{ required: true, message: '请输入物流编码', trigger: 'blur' }],
  }

  created() {
    this.getShippingCompany()
  }

  /**
   * 获取物流公司信息
   */
  getShippingCompany() {
    let id = this.$route.query['id']
    if (id) {
      ShippingCompany.getShippingCompany(id.toString()).then((res) => {
        this.form = res.data
      })
    }
  }

  picChange(e) {
    this.form.logo = e[0].url
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate((valid) => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        ShippingCompany.updateShippingCompany(vm.form, id).then((res) => {
          vm.$router.push({
            name: 'shippingCompany',
          })
        })
      }
    })
  }
}
